import {useQueryParamsCallback} from '@aboutyou/router';

export const FIRST_PRODUCT_ID_PARAM = 'firstProductId';

export const useFirstProductIds = (): number[] => {
  const firstProductIdParam = useGetFirstProductIdParam();

  const parenthesisRegExp = /\(([^()]+)\)/g;
  const matches = parenthesisRegExp.exec(firstProductIdParam ?? '');

  return matches && matches[1] ? matches[1].split(';').map(Number) : [];
};

const useGetFirstProductIdParam = () => {
  const getQueryParams = useQueryParamsCallback();
  const queryParams = getQueryParams();
  return queryParams.get(FIRST_PRODUCT_ID_PARAM);
};

export const useAppendFirstProductIdCallback = () => {
  const firstProductIdParam = useGetFirstProductIdParam();

  return (searchParam: URLSearchParams) => {
    const searchParams = new URLSearchParams(searchParam);
    if (firstProductIdParam) {
      searchParams.set(FIRST_PRODUCT_ID_PARAM, firstProductIdParam);
    }
    return searchParams.toString() === '' ? '' : `?${searchParams.toString()}`;
  };
};

export const buildFirstProductIdsQueryParam = (productIds: number[]) => {
  if (productIds.length === 0) {
    return '';
  }

  return `?${FIRST_PRODUCT_ID_PARAM}=(${productIds.join(';')})`;
};
